module.exports = __webpack_public_path__ + "static/media/viru.b26de5ee.png";